import { cn } from '@seen/ui'

// One look for every control that offers answers on an observation node: the
// side-by-side answers, and the triggers that open a list or a record search.
export function answerChipClass(picked = false): string {
  return cn(
    'inline-flex h-5 min-w-0 items-center gap-1 rounded-sm border border-gray-450 bg-card px-2 text-sm text-foreground leading-none hover:bg-gray-460 focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-zinc-950 disabled:cursor-not-allowed disabled:opacity-60',
    picked &&
      'border-primary bg-primary text-primary-foreground hover:bg-primary'
  )
}

// Several answers in one control, divided, rather than a chip each.
export function answerSegmentClass(): string {
  return 'inline-flex h-5 items-center gap-1.5 rounded-sm border border-border bg-card px-1.5 text-sm leading-[18px]'
}

// A box that opens a list of answers or takes typed input, its placeholder
// quiet.
export function answerTriggerClass(): string {
  return cn(answerSegmentClass(), 'border-stone-300 text-stone-400')
}

// The line between two answers in that control.
export function answerSegmentDividerClass(): string {
  return 'h-[18px] w-px shrink-0 bg-stone-300'
}

// A recorded answer reads as a link; clicking it offers the other answers.
export function answerValueClass(): string {
  return 'min-w-0 whitespace-normal text-left text-blue-600 hover:underline focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-zinc-950 disabled:cursor-not-allowed disabled:opacity-60'
}

// An earlier value offered again: a chip of the answers' size, muted and
// dashed so it does not read as one of them.
export function lastChipClass(): string {
  return 'ml-1 inline-flex h-5 min-w-0 max-w-[16rem] items-center gap-1 rounded-sm border border-gray-450 border-dashed px-2 text-sm text-muted-foreground leading-none hover:bg-gray-460 hover:text-foreground focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-zinc-950 disabled:cursor-not-allowed disabled:opacity-60'
}

// A button in a node's floating actions.
export function actionButtonClass(): string {
  return 'flex items-center rounded-[calc(var(--radius)-5px)] p-0.5 text-foreground-secondary hover:bg-gray-460 hover:text-foreground focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-zinc-950'
}
